export default "__VITE_ASSET__BwVSAfh6__"